import { defineStore } from 'pinia';
import type {
  Invitation,
  CreateInvitationPayload
} from '~/api/v1/invitations/InvitationRepository';
import {InvitationStatus} from "~/api/v1/invitations/InvitationRepository";

export const useInvitationStore = defineStore('invitation', {
  state: () => ({
    invitations: [] as Invitation[],
    invitation: null as Invitation | null,
    totalInvitations: 0,
    invitedCount: 0,
    isLoading: false,
    error: null as string | null,
  }),

  getters: {
    getInvitations: (state) => state.invitations,
    getTotalInvitations: (state) => state.totalInvitations,
    getInvitedCount: (state) => state.invitedCount,
  },
  
  actions: {
    async fetchInvitations(missionId: string) {
      this.invitations = [];
      this.isLoading = true;
      const { $api } = useNuxtApp();
      return $api().v1.invitations.fetchInvitations(missionId)
        .then((response) => {
          this.invitations = response;
          return response
        })
        .catch(error => {
          console.error('Error fetching invitations:', error);
          this.error = error instanceof Error ? error.message : 'Failed to fetch invitations';
          throw error;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // Fetch how many invitations are awaiting the current user's response.
    // Non-blocking: on error we keep the count at 0 (banner hidden).
    async fetchMyInvitedCount() {
      const { $api } = useNuxtApp();
      try {
        const response = await $api().v1.invitations.countMine();
        this.invitedCount = response.count;
        return response.count;
      } catch (error) {
        console.error('Error fetching invited invitations count:', error);
        this.invitedCount = 0;
        return 0;
      }
    },

    async updateInvitation(invitationId: string, status: InvitationStatus) {
      const { $api } = useNuxtApp();
      return $api().v1.invitations.update(invitationId, status).then((response: Invitation) => {
        return response
      })
    },

    async invitationInvite(mission_id: string, payload: { user_id: string }) {
      const { $api } = useNuxtApp();
      return $api().v1.missions.invite(mission_id, payload).then((response: Invitation) => {

        this.invitation = response
        this.invitations.push(response)

        return response
      })
    },

    async createInvitation(mission_id: string, payload: { user_id: string }) {
      const { $api } = useNuxtApp();
      return $api().v1.missions.join(mission_id, payload).then((response: Invitation) => {

        this.invitation = response
        this.invitations.push(response)

        return response
      })
    },
    
    // async fetchOneInvitation(invitationId: string) {
    //   const { $api } = useNuxtApp();
    //   return $api().v2.invitations.get(invitationId, {}).then((response: InvitationResponse) => {
    //       this.invitation = response;
    //       return response
    //   });
    // },
  },
});